export type AgentStatus = 'Available' | 'Available (On Demand)' | 'On Break' | 'Logged Out';
export type AgentState = 'Available' | 'In a queue call' | 'On Break' | 'Logged Out' | 'Busy' | 'Idle' | 'Waiting' | 'Receiving';

export function getAgentStateColor(state: AgentState | string): string {
  switch (state) {
    case 'In a queue call':
      return 'bg-red-500';
    case 'Receiving':
      return 'bg-orange-500 animate-pulse';
    case 'Available':
    case 'Waiting':
    case 'Idle':
      return 'bg-green-500';
    case 'On Break':
      return 'bg-yellow-500';
    case 'Logged Out':
      return 'bg-gray-500';
    case 'Busy':
      return 'bg-red-500';
    default:
      return 'bg-gray-400';
  }
}

export function getAgentStateBgColor(state: AgentState | string): string {
  switch (state) {
    case 'In a queue call':
      return 'bg-red-50 border-red-200';
    case 'Receiving':
      return 'bg-orange-50 border-orange-200';
    case 'Available':
    case 'Waiting':
    case 'Idle':
      return 'bg-green-50 border-green-200';
    case 'On Break':
      return 'bg-yellow-50 border-yellow-200';
    case 'Logged Out':
      return 'bg-gray-50 border-gray-200';
    case 'Busy':
      return 'bg-red-50 border-red-200';
    default:
      return 'bg-gray-50 border-gray-200';
  }
}

export function getAgentStateBadgeColor(state: AgentState | string): string {
  switch (state) {
    case 'In a queue call':
      return 'bg-red-100 text-red-700';
    case 'Receiving':
      return 'bg-orange-100 text-orange-700';
    case 'Available':
    case 'Waiting':
    case 'Idle':
      return 'bg-green-100 text-green-700';
    case 'On Break':
      return 'bg-yellow-100 text-yellow-700';
    case 'Logged Out':
      return 'bg-gray-100 text-gray-700';
    case 'Busy':
      return 'bg-red-100 text-red-700';
    default:
      return 'bg-gray-100 text-gray-700';
  }
}

export function getAgentStateLabel(state: AgentState | string): string {
  switch (state) {
    case 'In a queue call':
      return 'In Chiamata';
    case 'Receiving':
      return 'Squilla';
    case 'Available':
    case 'Waiting':
    case 'Idle':
      return 'Disponibile';
    case 'On Break':
      return 'In Pausa';
    case 'Logged Out':
      return 'Disconnesso';
    case 'Busy':
      return 'Occupato';
    default:
      return state || 'Sconosciuto';
  }
}

export function getAgentStatusLabel(status: AgentStatus | string): string {
  switch (status) {
    case 'Available':
    case 'Available (On Demand)':
      return 'Disponibile';
    case 'On Break':
      return 'In Pausa';
    case 'Logged Out':
      return 'Disconnesso';
    default:
      return status || 'Sconosciuto';
  }
}

export function getAgentStatusIcon(status: AgentStatus | string): 'headphones' | 'coffee' | 'log-out' | 'circle' {
  switch (status) {
    case 'Available':
    case 'Available (On Demand)':
      return 'headphones';
    case 'On Break':
      return 'coffee';
    case 'Logged Out':
      return 'log-out';
    default:
      return 'circle';
  }
}

export function getEffectiveAgentState(agent: { state?: string; status?: string }): AgentState {
  if (agent.state === 'In a queue call') return 'In a queue call';
  if (agent.state === 'Receiving') return 'Receiving';
  if (agent.status === 'On Break') return 'On Break';
  if (agent.status === 'Logged Out') return 'Logged Out';
  if (agent.state === 'Waiting' || agent.state === 'Idle' || agent.status === 'Available') return 'Available';
  return (agent.state as AgentState) || 'Available';
}
